<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
            #{{fc.ID.value}}
        </div>
               <!-- Opis -->
        <div class="row">
            <div class="col-lg-12 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-text-area
                        #autofocus
                        #txtIntermediary
                        [MaxLength]="2000" 
                        name="txtIntermediary" 
                        formControlName="Intermediary"
                        [Label]="'INSTRUKCIJAPLACANJA.INTERMEDIARY.SINGULAR'" 
                        [Height]="1"
                        [ngClass]="{'is-invalid': submitted && fc.Intermediary.invalid}">
                      </yt-text-area>
                        <div class="form-error" *ngIf="submitted && fc.Intermediary.invalid">
                            <span *ngFor="let validation of errorMessages.Opis">
                              <span class="error-message" *ngIf="fc.Opis.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                          </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
